<template>
  <div :class="formClass">
    <label class="control-label col-md-3">
      {{ label }}
    </label>
    <div class="col-md-9">
      <vue-ckeditor
        ref="ckeditor"
        :value="value"
        :config="config"
        @input="updateValue($event)"
      ></vue-ckeditor>
      <span v-if="hasError" class="help-block">
          <p> {{ errorText }} </p>
      </span>
    </div>
  </div>
</template>

<script>
import VueCkeditor from 'vue-ckeditor2'

export default {
  components: {
    VueCkeditor
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    errors: {
      type: Object,
      default: () => ({}),
    }
  },
  data: function () {
    return {
      text: null,
      config: {
        height: 300,
        // eslint-disable-next-line no-undef
        enterMode : CKEDITOR.ENTER_BR
      },
    }
  },
  computed: {
    errorText: function () {
      if (this.errors[this.name]) {
        return Object.values(this.errors[this.name]).join()
      }

      return ''
    },
    hasError: function () {
      return this.errorText !== ''
    },
    formClass: function () {
      return this.hasError ? 'form-group has-error' : 'form-group'
    }
  },
  methods: {
    updateValue(event) {
      this.$emit('input', event)
    },
  },
}
</script>
